import { Component, Injector, ViewChild } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'rejected-app',
  template: require('./rejected-app.component.html'),
  styles: [require('./rejected-app.component.scss')]
})
export class RejectedAppComponent extends BaseRoute {
  @ViewChild('focusItem') focusItem;
  constructor(injector: Injector) {
    super(injector);
    this.loadingNext = false;
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
  }

  ngAfterViewInit() {
    if (this.focusItem) {
      this.focusItem.nativeElement.focus();
    }

  }
}
